import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthorizationGuard } from './core/guards/authentication.guard';
import { PermissionGuard } from './core/guards/permission.guard';
import { FirstLoadGuard } from './core/guards/first-load.guard';
import { AppComponent } from './app.component';
import { HomeComponent } from './modules/landing-page/home/home.component';
// import { ContactComponent } from './modules/landing-page/contact/contact.component';
// import { AboutComponent } from './modules/landing-page/about/about.component';
// import { ForBuyerComponent } from './modules/landing-page/for-buyer/for-buyer.component';
// import { ForCarrierComponent } from './modules/landing-page/for-carrier/for-carrier.component';
import { Landinguard } from './core/guards/landing.guard';
import { SignUpComponent } from './modules/sign-up/sign-up.component';
import {  LoginComponent } from './modules/login/login.component';

// import { TermsOfUseComponent } from './modules/landing-page/terms-of-use/terms-of-use.component';
// import { PrivacyPolicyComponent } from './modules/landing-page/privacy-policy/privacy-policy.component';

const routes: Routes = [
  {
    path: '', canActivate: [AuthorizationGuard], runGuardsAndResolvers: 'always',
    children: [
      { path: '', pathMatch: 'full', component: AppComponent, canActivate: [FirstLoadGuard] },
      { path: 'request', loadChildren: './modules/request/request.module#RequestModule' },
      { path: 'user', loadChildren: './modules/user/user.module#UserModule' },
      { path: 'freight-post', loadChildren: './modules/freight-post/freight-post.module#FreightPostModule' },
    ],
  },
  { path: 'home', component: HomeComponent },

  { path: 'about', loadChildren: './modules/landing-page/about/about.module#AboutModule' },
  {
    path: 'how-it-works', loadChildren: './modules/landing-page/how-it-works/how-it-works.module#HowItWorksModule'
  },
  { path: 'for-buyer', loadChildren: './modules/landing-page/for-buyer/for-buyer.module#ForBuyerModule' },
  {
    path: 'for-carrier', loadChildren: './modules/landing-page/for-carrier/for-carrier.module#ForCarrierModule'
  },
  {
    path: 'terms-of-use',
    loadChildren: './modules/landing-page/terms-of-use/terms-of-use.module#TermsOfUseModule'
  },
  {
    path: 'privacy-policy',
    loadChildren: './modules/landing-page/privacy-policy/privacy-policy.module#PrivacyPolicyModule'
  },
  {
    path: 'terms-and-conditions',
    loadChildren: './modules/landing-page/terms-and-conditions/terms-and-conditions.module#TermsAndConditionsModule'
  },
  { path: 'login', component: LoginComponent },
  {
    path: 'sign-up',
    component: SignUpComponent
  },
  {
    path: '**',
    redirectTo: '/'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload', scrollPositionRestoration: 'enabled' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
